/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeDraftVersion } from './EmployeeDraftVersion';
import type { EmployeeExecutionBlocker } from './EmployeeExecutionBlocker';
import type { EmployeeExecutionNativeOperationKind } from './EmployeeExecutionNativeOperationKind';
import type { EmployeeExecutionObjectiveOutcome } from './EmployeeExecutionObjectiveOutcome';
import type { EmployeeExecutionStatus } from './EmployeeExecutionStatus';
import type { EmployeePublishedVersion } from './EmployeePublishedVersion';
/**
 * Deterministic native work displayed alongside an execution's phase history.
 */
export type EmployeeExecutionNativeOperationActivity = {
    /**
     * Discriminator separating native work from employee and workflow steps.
     */
    activityType: EmployeeExecutionNativeOperationActivity.activityType;
    /**
     * Tenant that owns the execution.
     */
    tenantId: string;
    /**
     * Employee that owns the execution.
     */
    employeeId: string;
    /**
     * Employee version used by the execution.
     */
    version: (EmployeePublishedVersion | EmployeeDraftVersion);
    /**
     * Execution that performed the native operation.
     */
    executionId: string;
    /**
     * Stable idempotency key for the native operation.
     */
    operationKey: string;
    /**
     * Deterministic operation performed by the runtime.
     */
    operationKind: EmployeeExecutionNativeOperationKind;
    /**
     * Number of reserved attempts for this operation.
     */
    attemptCount: number;
    /**
     * Latest persisted lifecycle state of the operation.
     */
    status: EmployeeExecutionNativeOperationActivity.status;
    /**
     * ISO timestamp of the latest operation-state transition.
     */
    occurredAt: string;
    /**
     * Latest implementation-owned failure code or sanitized error.
     */
    lastError?: string;
    /**
     * Stable resource identifier produced by a successful operation.
     */
    resultReference?: string;
    /**
     * Current lifecycle status of the parent execution.
     */
    executionStatus: EmployeeExecutionStatus;
    /**
     * Terminal business outcome of the parent objective.
     */
    objectiveOutcome?: EmployeeExecutionObjectiveOutcome;
    /**
     * ISO timestamp when the parent objective reached a terminal outcome.
     */
    objectiveFinishedAt?: string;
    /**
     * Structured blocker when this native operation blocked the objective.
     */
    blocker?: EmployeeExecutionBlocker;
};
export namespace EmployeeExecutionNativeOperationActivity {
    /**
     * Discriminator separating native work from employee and workflow steps.
     */
    export enum activityType {
        NATIVE_OPERATION = 'native-operation',
    }
    /**
     * Latest persisted lifecycle state of the operation.
     */
    export enum status {
        SUCCEEDED = 'succeeded',
        BLOCKED = 'blocked',
        IN_PROGRESS = 'in-progress',
    }
}

